import React, { FC } from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Spacer from 'evcharging/components/Spacer';
import useI18n from 'evcharging/hooks/useI18n';
import Paragraph from 'evcharging/components/Paragraph';
import Caption from 'evcharging/components/Caption';
import commitment from 'assets/about-us/commitment.png';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import LinkButton from 'evcharging/components/LinkButton';
import { CONTACT_US_URL } from 'config/seo/urls';

const OurCommitment: FC = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  return (
    <Section background={'light'}>
      <Container>
        <Caption>
          {t('about-us.our-commitment')}
        </Caption>
        <Spacer value={12} />
        <Paragraph size={'large'} textAlign={'center'} color={'middle'}>
          {t('about-us.our-vision')}
        </Paragraph>
        <Spacer value={36} />
        <Paragraph textAlign={'center'}>
          <LinkButton href={CONTACT_US_URL}>{t('about-us.get-started')}</LinkButton>
        </Paragraph>
      </Container>
      <div className={styles.bg} />
    </Section>
  );
};

const createStyles = (theme: Theme) => ({
  bg: css`
    background-image: url(${commitment});
    background-repeat: repeat-x;
    height: 134px;
    width: 100%;
    border-bottom: 1px #D5DADD solid;
  `
});

export default OurCommitment;
